document.addEventListener('DOMContentLoaded', function () {
  // Run only on collection or search pages
  const bodyClass = document.body.className || '';
  if (!bodyClass.includes('collection') && !bodyClass.includes('search')) {
    return;
  }

  // Find numeric prices in product cards
  const priceNodes = document.querySelectorAll(
    'price, [x-ml*="formatMoney"], .money, [class*="money"], [class*="amount"]'
  );

  priceNodes.forEach(function (el) {
    const text = (el.textContent || '').trim();

    // Ignore empty and "Call us..."
    if (!text || /call us/i.test(text)) return;

    // Apply visual style
    el.style.setProperty('font-size', '1.05rem', 'important');
    el.style.setProperty('font-weight', '600', 'important');
    el.style.setProperty('color', '#1a1a1a', 'important');
    el.style.setProperty('display', 'inline-block', 'important');
    el.style.setProperty('text-align', 'center', 'important');

    // Optional: normalize parent spacing
    const parent = el.closest('p') || el.parentElement;
    if (parent) {
      parent.style.setProperty('margin-top', '6px', 'important');
      parent.style.setProperty('margin-bottom', '0', 'important');
      parent.style.setProperty('text-align', 'center', 'important');
    }
  });
});
